import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";
import { InstallationGroupTitle } from "styles/ModalCommonStyled";

export const Container = styled.div`
  width: 100%;
  position: relative;
  ${mediaQuery.isDefault} {
    height: calc(100vh - 160px);
    overflow: hidden;
  }
`;

export const AccountName = styled.div`
  ${FLEX.FlexStartStart};
  gap: 4px;
  flex-direction: column;
`;

export const SpinnerContainer = styled.div`
  position: absolute;
  z-index: 777;
  width: 100%;
  height: 100%;
`;

export const Top = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.COLORS.PRIMARY3};
  border-radius: 4px;
  padding: 20px;
  ${FLEX.FlexBetweenCenter};

  ${mediaQuery.isTablet} {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .refresh-button {
    :hover {
      > svg {
        path {
          fill: ${({ theme }) => theme.COLORS.WHITE};
        }
      }
    }
  }
`;

export const Header = styled.ul`
  ${FLEX.FlexStartStart};
  gap: 50px;
  flex: 4;

  ${mediaQuery.isMobile} {
    ${FLEX.FlexStartStart};
    gap: 18px;
    flex-direction: column;
  }
`;

export const HeaderItem = styled.li`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 8px;

  h3 {
    font-size: ${calcRem(12)};
    font-weight: 600;
    color: ${({ theme }) => theme.COLORS.WHITE}70;
    text-transform: uppercase;
  }

  p {
    font-size: ${calcRem(16)};
    color: ${({ theme }) => theme.COLORS.WHITE};
  }

  ${mediaQuery.isMobile} {
    flex-direction: row;
    gap: 16px;
  }
`;

export const ButtonWrapper = styled.div`
  ${FLEX.FlexEndCenter};
  gap: 10px;

  ${mediaQuery.isDefault} {
    button {
      padding: 12px 10px;
      min-width: 100px;
    }
  }
`;

export const Grid = styled.div`
  ${mediaQuery.isDefault} {
    display: grid;
    grid-template-columns: auto 240px;
    grid-template-rows: repeat(2, auto);
    /* height: 500px; */
    gap: 10px;
    margin-top: 30px;
    padding-bottom: 40px;
    height: calc(100% - 95px);
  }

  ${mediaQuery.isMobile} {
    width: 100%;
    ${FLEX.FlexStartStart};
    flex-direction: column-reverse;
    gap: 26px;
    margin-top: 20px;

    .title {
      min-width: 20%;
    }
  }
`;

export const LeftAside = styled.section`
  width: 100%;
  height: 100%;
  ${mediaQuery.isDefault} {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: min-content;
    gap: 20px;
    overflow-y: auto;
    min-height: 0;
    min-height: 35vh;
    min-width: 0;
  }
  @media (max-width: 1300px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }
  ${mediaQuery.isMobile} {
    ${FLEX.FlexStartStart};
    flex-direction: column;
    gap: 20px;
  }
`;

export const CameraItem = styled.div`
  /* overflow: hidden; */
  border-radius: 0 0 4px 4px;
  background-color: ${({ theme }) => theme.COLORS.PRIMARY3};
  white-space: nowrap;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
`;

export const CameraContent = styled.ul`
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
  padding: 10px 15px;
  width: 100%;
  max-width: 100%;

  /* box-sizing: border-box; */
`;

export const CameraContentRow = styled.li`
  ${FLEX.FlexStartCenter};
  flex: 1;
  width: 100%;
  max-width: 100%;

  + li {
    margin-top: 7px;
  }

  ${mediaQuery.isDefault} {
    .ip-address {
      flex: 1;
      width: 100%;
      overflow: hidden;

      > span {
        font-size: ${calcRem(12)};
        color: ${({ theme }) => theme.COLORS.WHITE};
        width: 100%;
        text-overflow: ellipsis;
      }
    }
  }

  .ant-typography {
    margin-bottom: 0 !important;
    color: ${({ theme }) => theme.COLORS.WHITE};
    font-size: ${calcRem(13)};
  }
  .title {
    flex: 1;
    min-width: 65px;
    max-width: 65px;
  }
  .content {
    flex: 2;
    white-space: normal;
  }
  .copy {
    width: 12px;
  }
`;

export const Copy = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 6px;
  overflow: hidden;
  white-space: nowrap;
`;

export const RightAside = styled.aside`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  background-color: ${({ theme }) => theme.COLORS.PRIMARY3};
  padding: 20px;
  border-radius: 4px;
  gap: 30px;

  ${mediaQuery.isDefault} {
    height: 100%;
    overflow-y: auto;
  }

  ${mediaQuery.isMobile} {
    width: 100%;
  }
`;
export const RightWrapperTitle = styled(InstallationGroupTitle)`
  color: ${({ theme }) => theme.COLORS.SELECTED};
  width: 100%;
  b {
    background-color: ${({ theme }) => theme.COLORS.PRIMARY3};
  }
  &::before {
    background-color: ${({ theme }) => theme.COLORS.SELECTED};
  }
  margin-top: 12px;
`;

export const RightWrapper = styled.div`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  width: 100%;
`;
export const RightItemWrapper = styled.ul`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 12px;
  width: 100%;
  li:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

export const ConfirmModalTitle = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 12px;
  color: ${COLORS.COMPANY};
  font-size: ${calcRem(20)};
  font-weight: 500;
  padding-bottom: 20px;
  margin-top: -10px;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.COLORS.LIGHTGRAYBORDER};
  ${mediaQuery.isMobile} {
    margin-top: 0;
    padding-bottom: 10px;
    font-size: ${calcRem(18)};
  }
`;

export const ConfirmModalContent = styled.div`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 12px;
  text-align: left;
  padding: 20px 0 0;
  font-size: ${calcRem(14)};
  line-height: 1.25;
  color: ${({ theme }) => theme.COLORS.WHITE};
`;

export const RightItem = styled.li<{ noBorder?: boolean }>`
  ${FLEX.FlexStartStart};
  width: 100%;
  flex-direction: column;
  border-bottom: 1px solid ${COLORS.BUTTONS1}50;
  padding-bottom: 12px;
  gap: 4px;
  h4 {
    font-size: ${calcRem(12)};
    font-weight: 600;
    color: ${({ theme }) => theme.COLORS.WHITE}70;
    text-transform: uppercase;
  }

  p {
    font-size: ${calcRem(14)};
    color: ${({ theme }) => theme.COLORS.WHITE};
  }

  ${mediaQuery.isDefault} {
    div {
      font-size: ${calcRem(14)};
    }

    .address {
      word-break: keep-all;
      white-space: normal;
      text-overflow: unset;
    }
  }
  ${mediaQuery.isMobile} {
    ${({ noBorder }) =>
      noBorder &&
      `
      border: none;
    `}
  }
`;
